<template>
  <div class="nc-main-ess-side" :style="{ top: fixed ? '63px' : 245 - scrollTop + 'px' }">
    <div class="progerss">
      <div class="progress-two">
        <div class="progress-side-btn" :class="{ 'active-btn': active === 0 }"></div>
        <div class="progress-mian" :class="{ active: active === 0 }" @click="scrollTo(0)">
          <span class="text_148">基本信息</span>
        </div>
      </div>
      <div class="progress-bottom">
        <div class="progress-bottom-child"></div>
      </div>
      <div class="progress-two">
        <div class="progress-side-btn" :class="{ 'active-btn': active === 1 }"></div>
        <div class="progress-mian" :class="{ active: active === 1 }" @click="scrollTo(1)">
          <span class="text_148">课程介绍</span>
        </div>
      </div>
      <div class="progress-bottom">
        <div class="progress-bottom-child"></div>
      </div>
      <div class="progress-two">
        <div class="progress-side-btn" :class="{ 'active-btn': active === 2 }"></div>
        <div class="progress-mian" :class="{ active: active === 2 }" @click="scrollTo(2)">
          <span class="text_148">上传图片</span>
        </div>
      </div>
      <div class="progress-bottom">
        <div class="progress-bottom-child"></div>
      </div>
      <div class="progress-two">
        <div class="progress-side-btn" :class="{ 'active-btn': active === 3 }"></div>
        <div class="progress-mian" :class="{ active: active === 3 }" @click="scrollTo(3)">
          <span class="text_148">章节设置</span>
        </div>
      </div>
      <div class="progress-bottom">
        <div class="progress-bottom-child"></div>
      </div>
      <div class="progress-two">
        <div class="progress-side-btn" :class="{ 'active-btn': active === 4 }"></div>
        <div class="progress-mian" :class="{ active: active === 4 }" @click="scrollTo(4)">
          <span class="text_148">推荐课程</span>
        </div>
      </div>
      <div class="progress-bottom">
        <div class="progress-bottom-child"></div>
      </div>
      <div class="progress-two">
        <div class="progress-side-btn" :class="{ 'active-btn': active === 5 }"></div>
        <div class="progress-mian" :class="{ active: active === 5 }" @click="scrollTo(5)">
          <span class="text_148">常见问题</span>
        </div>
      </div>
      <!-- <div class="progress-bottom">
        <div class="progress-bottom-child"></div>
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  props: {
    active: {
      type: Number,
      default: 0
    },
    fixed: {
      type: Boolean,
      dafault: false
    },
    scrollTop: {
      type: Number,
      default: ""
    }
  },
  methods: {
    scrollTo (param) {
      this.$emit('scrollTo', param)
    },
  },
}
</script>
<style lang="scss" scoped>
.progerss {
  padding-top: 18px;
}

.top-right {
  width: 28px;
  height: 20px;
  color: rgba(28, 105, 212, 1);
  font-size: 14px;
  white-space: nowrap;
  line-height: 20px;
}

.nc-main-ess-side {
  width: 144px;
  height: 476px;
  background: #ffffff;
  margin-left: 15px;
  margin-right: -126px;
  top: 245px;
}

.progress-two {
  display: flex;
  width: 96px;
  height: 24px;
  margin: 2px 0 0 24px;

  .progress-side-btn {
    width: 8px;
    height: 8px;
    background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngcdb9356410b4b0578a6cd8cbffe6624eac9ef10bb121d70d1ced16c14ffb62ea) 100% no-repeat;
    background-size: 100% 100%;
    margin-top: 8px;
    background-color: #C8C9CC;
    border-radius: 3px;
  }

  .progress-mian {
    border-radius: 2px;
    height: 24px;
    border: 1px solid rgba(200, 201, 204, 1);
    width: 80px;
    margin-left: 8px;

    .text_148 {
      width: 56px;
      height: 20px;
      color: rgba(90, 92, 96, 1);
      font-size: 14px;
      text-align: left;
      white-space: nowrap;
      line-height: 20px;
      margin: 2px 0 0 12px;
    }
  }
}

.progress-bottom {
  width: 2px;
  height: 44px;
  margin: 2px 0 0 27px;
  background-color: #c8c9cc;

  .progress-bottom-child {
    width: 2px;
    height: 44px;
    background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng9d0bd20d9dab64fd5ded7ace3af83c5281b3f9cd88e70e2f525c3d412e13a56e) 100% no-repeat;
    background-size: 100% 100%;
    background-color: #C8C9CC;
  }
}

.progress-one {
  width: 96px;
  height: 24px;
  margin: 26px 0 0 24px;
  display: flex;

  .progress-side-btn {
    width: 8px;
    height: 8px;
    background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng9bc07e99473d2cbdeb1f69679aa22ab5c0f36e25a0d3b5c106b29d36b6e0785c) 100% no-repeat;
    background-size: 100% 100%;
    margin-top: 8px;
  }

  .progress-mian {
    border-radius: 2px;
    height: 24px;
    border: 1px solid rgba(28, 105, 212, 0.6);
    width: 80px;
    margin-left: 8px;

    .text_148 {
      width: 56px;
      height: 20px;
      color: rgba(21, 91, 212, 1);
      font-size: 14px;
      text-align: left;
      white-space: nowrap;
      line-height: 20px;
      margin: 2px 0 0 12px;
    }
  }
}

.progress-bottom {
  width: 2px;
  height: 44px;
  margin: 2px 0 0 27px;
  background-color: #c8c9cc;

  .progress-bottom-child {
    width: 2px;
    height: 44px;
    background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng9d0bd20d9dab64fd5ded7ace3af83c5281b3f9cd88e70e2f525c3d412e13a56e) 100% no-repeat;
    background-size: 100% 100%;
  }
}
</style>